import axios from 'axios';
import { _typeof, tip } from '../util/util';

export const toLogin = router => {
  router.replace({
    path: '/login',
    query: {
      redirect: router.currentRoute.fullPath
    }
  });
};

export const errorHandler = (response, router, store) => {
  switch (response.status) {
    // 401: 未登录状态，跳转登录页
    case 401:
      toLogin(router);
      break;
    // 403 token过期
    // 登录过期对用户进行提示
    // 清除本地token 和清空 vuex 中 token对象
    // 跳转登录页面
    case 403:
      tip('登录过期，请重新登录！');
      // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
      setTimeout(() => {
        toLogin(router);
      }, 1000);
      break;
    // 404: 请求不存在
    case 404:
      tip('请求的资源不存在！');
      break;
    case 405:
      tip('请求方式错误！');
      break;
    case 500:
      tip(`服务器内部错误：${response.data.message}！`);
      break;
    case 504:
      tip('网关错误！');
      break;
  }
};

export const getHOM = instance => (url, params) =>
  new Promise((resolve, reject) => {
    instance
      .get(url, { params })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        !err ? reject(err) : reject(err.data);
      });
  });

export const deleteHOM = instance => (url, params) =>
  new Promise((resolve, reject) => {
    instance
      .delete(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        !err ? reject(err) : reject(err.data);
      });
  });

export const postHOM = instance => (url, params, config) =>
  new Promise((resolve, reject) => {
    instance
      .post(url, params, config)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        !err ? reject(err) : reject(err.data);
      });
  });

export const patchHOM = instance => (url, params, config) =>
  new Promise((resolve, reject) => {
    instance
      .patch(url, params, config)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        !err ? reject(err) : reject(err.data);
      });
  });

export const putHOM = instance => (url, params, config) =>
  new Promise((resolve, reject) => {
    instance
      .put(url, params, config)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        !err ? reject(err) : reject(err.data);
      });
  });

export function storeApiPluginHOM (instance) {
  return function (store) {
    store.watch(
      state => state.authHeader,
      authHeader => {
        if (authHeader) {
          instance.defaults.headers.common['Authentication'] = authHeader;
        } else {
          delete instance.defaults.headers.common['Authentication'];
        }
      }
    );
  };
}

export default function createAxios (options, router, store) {
  axios.defaults.withCredentials = true;

  const instance = axios.create(options);
  if (options.defaults) {
    Object.keys(options.defaults).forEach(type => {
      const value = options.defaults[type];
      if (_typeof(value) === 'object') {
        for (let [k, v] of Object.entries(value)) {
          instance.defaults.headers[type][k] = v;
        }
      } else {
        instance.defaults[type] = value;
      }
    });
  }

  instance.interceptors.request.use(
    config => config,
    error => Promise.reject(error.response)
  );

  instance.interceptors.response.use(
    response => {
      if (response.status !== 200) return Promise.reject(response);
      if (response.data.code === -999) {
        return toLogin(router);
      } else if (response.data.code !== 1 && response.data.code !== 350) {
        if (process.env.NODE_ENV === 'development') {
          tip(`
            接口地址: ${response.config.url}
            错误信息: ${response.data.msg}
          `);
        } else {
          // tip(response.data.msg)
        }
      }
      return Promise.resolve(response);
    },
    error => {
      if (!error.response) {
        if (error.message.includes('timeout')) {
          tip('请求超时，请检查网络是否连接正常！')
        } else {
          tip('请求失败，请检查网络是否已连接！');
        }
        return
      }
      const { response } = error;
      if (response) {
        errorHandler(response, router, store);
      }
      return Promise.reject(error.response);
    }
  );

  return instance;
}
